import { useEffect } from 'react'

// This is an unattended terminal: a human is not standing by to reload it.
// If a render error ever slips past the fixes elsewhere in this branch,
// self-heal rather than sit on a dead screen indefinitely.
export const RELOAD_AFTER_MS = 15000

export default function ErrorFallback() {
  useEffect(() => {
    const timer = setTimeout(() => window.location.reload(), RELOAD_AFTER_MS)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 bg-bg">
      <img src="/images/logo-horizontal.svg" alt="Loving Loyalty" className="h-9" />
      <div className="h-2.5 w-2.5 animate-logo-spin rounded-full border-2 border-divider border-t-accent" />
    </div>
  )
}
